<template>
    <div class="header li_none_style" :class="[useTransparentHeader ? transparentHeader.header_class : colorHeader.header_class]" ref="header">
        <ul class="header-box">
            <a href="/">
                <li class="header_logo">
                    <img
                    class="header_logo-img"
                    :src="[useTransparentHeader ? transparentHeader.header_logo : colorHeader.header_logo]"
                    />
                    
                </li>
            </a>
            <div
            class="menu-list"
            v-if="bigScreen">
                <li
                v-for="item in items"
                :key="item.id">
                    <a
                    v-scroll-to="item.path"
                        :class="[useTransparentHeader ? transparentHeader.header_class : colorHeader.header_class]"
                    style="cursor: pointer;">
                        <div class="header-title-ch">{{ item.ch_text }}</div>
                        <div class="header-title-en">{{ item.en_text }}</div>
                    </a>
                </li>
            </div>
            <div
            v-else
            class="menu-list"
            @click="showMenu"
            >
            <a>
                <div class="menu-list_main_text">menu</div>
                <div class="menu_bar">
                <div :class="['bar-line', 'bar-top', useTransparentHeader ? transparentHeader.header_menu_class : colorHeader.header_menu_class]"></div>
                <div :class="['bar-line', 'bar-down', useTransparentHeader ? transparentHeader.header_menu_class : colorHeader.header_menu_class]"></div>
                </div>
            </a>
            </div>
        </ul>

        <app-menu
            v-show="isMenuVisible"
            :menuObj="items"
            @close="showMenu"/>
    </div>
</template>

<script>
    import Menu from '@/components/Menu.vue'

    export default {
        name: 'Header',
        components: {
            'app-menu': Menu
        },
        data() {
            return {
                items: [
                    {
                        ch_text: '服務與技術',
                        en_text: 'SUPPORTS',
                        path: '#support'
                    }, {
                        ch_text: '開發成果',
                        en_text: 'PRODUCTS',
                        path: '#products'
                    }, {
                        ch_text: '關於雲灣',
                        en_text: 'ABOUT',
                        path: '#about'
                    }
                ],
                scrollInTopPosition: true,
                colorHeader: {
                    header_class: 'header-color',
                    header_menu_class: 'header-menu',
                    header_logo: new URL('../assets/images/2x/cblogo_blue@2x.png', import.meta.url).href
                },
                transparentHeader: {
                    header_class: 'header-transparent',
                    header_menu_class: 'header-menu-transparent',
                    header_logo: new URL('../assets/images/2x/cblogo_white@2x.png', import.meta.url).href
                },
                windowWidth: 0,
                bigScreen: true,
                isMenuVisible: false
            }
        },
        computed: {
            useTransparentHeader() {
                return this.$route.path === '/' && this.scrollInTopPosition
            }
        },
        methods: {
            updateScroll() {
                if (window.scrollY) {
                    this.scrollInTopPosition = false;
                }
                else {
                    this.scrollInTopPosition = true;
                }
            },
            screen_sencor() {
                if (window.innerWidth > 768) {
                    this.bigScreen = true;
                    this.isMenuVisible = false
                }
                else {
                    this.bigScreen = false;
                }
            },

            showMenu: function () {
                this.isMenuVisible = !this.isMenuVisible
                if (this.isMenuVisible) {
                    this.scrollInTopPosition = false;
                    document.body.classList.add("page-fix");
                }
                else {
                    this.updateScroll()
                    document.body.classList.remove("page-fix");
                }
            }
        },
        mounted() {
            this.screen_sencor()
            window.addEventListener('scroll', this.updateScroll);

            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.screen_sencor()
                });
            })
        }
    }
</script>
